'use client';

import { Dialog, dialog } from '@flipster/react/design-system/dialog';
import { checkAxiosError } from '@flipster/utils/axios';
import { isServer } from '@flipster/utils/env-helper';
import { getErrorMessage } from '@flipster/utils/error';

export function showErrorDialog(err: unknown, options: { onlyAxiosError?: boolean } = {}) {
  if (options.onlyAxiosError && !checkAxiosError(err)) return;
  if (!isServer && window.location.pathname === '/maintenance') {
    dialog.close();
    return;
  }
  const message = getErrorMessage(err);
  if (!message) return;
  dialog.open({
    title: { label: 'Notice' },
    content: message,
    buttons: {
      primary: <Dialog.Button hierarchy='primary' label='Confirm' />,
    },
  });
}
